/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>login.component.ts</name>
///
/// <description>
///
/// </description>
///
/// <author>Yaron Habot</author>
/// <created>15 Sept 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 15Sept16 YH  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import { Component, ElementRef, Renderer } from '@angular/core';
import { HydUser } from '../../models/user'
import {  AzureADAuthLoginComponent } from '../azure-active-directory/azure-ad-auth-login/azure-ad-auth-login.component'
import { TranslatedStringsService } from '../../services/language.service';
import { PortalVersionService } from '../../services/portal-version.service';

@Component({
    selector: 'login',
    templateUrl: './login.component.html'
})
export class LoginComponent {

    userContext: HydUser
    private lblServiceStatus: string;
    private lblProductTitle: string;
    private portalVersion: string;

    constructor(userCtx: HydUser,
        private i18n: TranslatedStringsService,
        private elementRef: ElementRef,
        private renderer: Renderer,
        private portalVersionService: PortalVersionService
    ) {
        this.userContext = userCtx;
    }

    ngOnInit() {

        this.translate();
        this.getPortalVersion();
        //document.getElementById("menu-resize-btn").style.visibility = "hidden";
        document.getElementById("usr-info").style.visibility = "hidden";


        let container = this.elementRef.nativeElement.parentElement.parentElement;
        if (container) {
            this.renderer.setElementStyle(container, 'background-color', '#343A3E');
        }
    }

    private translate() {
        this.i18n.init2().then((data) => {
            this.lblServiceStatus = this.i18n.translate("service-status");
            this.lblProductTitle = this.i18n.translate("product-title");
        });

    }

    private getPortalVersion() {
        this.portalVersionService.getVersion()
            .subscribe(res => {
                this.portalVersion = res.portalVersionNumber;
            });
    }

}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/authentication/login/login.component.ts